export interface Resource {
  title: string,
  type: string,
  src: string,
  icon?: string,
  tags: string[],
}

export interface ResourceType {
  type: string,
  icon: string,
  label: string,
}

export interface ResourceGroup {
  icon: string,
  label: string,
  tags: string[]
}

export const documents:Resource[] = [
  {
    title: 'Quick Start & Best Practices Guide',
    type: 'doc',
    src: 'https://privatefootprint.sharepoint.com/:w:/s/PrivateFootprintCorporation/ERnzZWRvZXpDsljWbqBkWp4BSNHyRf51SGGM_3PMJBtvog?e=WyGUYO',
    icon: 'fa fa-file-alt',
    tags: ['law-firm'],
  },
  {
    title: 'How to Add a New Client',
    type: 'doc',
    src: 'https://scribehow.com/shared/How_to_Add_a_New_Client__39smTAhUS_O9tZkRvVyTJA?referrer=documents',
    icon: 'fa fa-file-alt',
    tags: ['law-firm'],
  },
  {
    title: 'How to Add a New Law Firm User',
    type: 'doc',
    src: 'https://scribehow.com/shared/How_to_Add_a_New_Law_Firm_User__hoD2zXvHRB298Yf7IkfNkw?referrer=documents',
    icon: 'fa fa-file-alt',
    tags: ['law-firm'],
  },
  {
    title: 'How to Transfer Clients Between Law Firm Users',
    type: 'doc',
    src: 'https://scribehow.com/shared/How_to_Transfer_Clients_Between_Law_Firm_Users__wM6PdIOYQN-flh-FiD90HA?referrer=documents',
    icon: 'fa fa-file-alt',
    tags: ['law-firm'],
  },
  {
    title: 'How to Create and Download Reports',
    type: 'doc',
    src: 'https://scribehow.com/shared/How_to_Create_and_Download_Reports__nnqRSdh7QbiAXa3WfiVgWw',
    icon: 'fa fa-file-alt',
    tags: ['law-firm'],
  },
  {
    title: 'How to Request a Facebook & Instagram Update',
    type: 'doc',
    src: 'https://scribehow.com/o/5xHa3T97RASzqDPulTOvpw/viewer/How_to_request_a_Facebook_and_Instagram_Update__szVS4n-kRRG-6qRzU1qi1g',
    icon: 'fa fa-file-alt',
    tags: ['law-firm'],
  },
  {
    title: 'How to Add a Payment Method',
    type: 'doc',
    src: 'https://scribehow.com/shared/How_to_Add_a_Payment_Method__D5svjkPPS_K7LHoJJjOl2A?referrer=documents',
    icon: 'fa fa-file-alt',
    tags: ['law-firm'],
  },
  {
    title: 'How to Download a Receipt',
    type: 'doc',
    src: 'https://scribehow.com/shared/How_to_Download_a_Receipt__hEyIdUDCRXaWnskf0qAn0A?referrer=documents',
    icon: 'fa fa-file-alt',
    tags: ['law-firm'],
  },
  {
    title: 'Sample Retainer Agreement Clause (Word)',
    type: 'doc',
    src: 'https://private-footprint-prod.s3.ca-central-1.amazonaws.com/resources/docs/lawyer/Sample Social Media Retainer Clause (Word).docx',
    icon: 'fa fa-file-word',
    tags: ['law-firm'],
  },
  {
    title: 'Explanatory Email to Clients - English (Word)',
    type: 'doc',
    src: 'https://private-footprint-prod.s3.ca-central-1.amazonaws.com/resources/docs/client/Explanatory Email to Clients - English (Word).docx',
    icon: 'fa fa-file-word',
    tags: ['client'],
  },
  {
    title: 'Explanatory Email to Clients - Spanish (Word)',
    type: 'doc',
    src: 'https://private-footprint-prod.s3.ca-central-1.amazonaws.com/resources/docs/client/Explanatory Email to Clients - Spanish (Word).docx',
    icon: 'fa fa-file-word',
    tags: ['client'],
  },
];

export const videos:Resource[] = [
  {
    title: 'Explanatory Video for Clients (English)',
    type: 'video',
    src: 'https://player.vimeo.com/video/1056207295?h=791abd492d&badge=0&autopause=0&player_id=0&app_id=58479',
    icon: 'fa fa-file-video',
    tags: ['client'],
  },
  {
    title: 'Explanatory Video for Clients (Spanish)',
    type: 'video',
    src: 'https://player.vimeo.com/video/1061413187?badge=0&autopause=0&player_id=0&app_id=58479',
    icon: 'fa fa-file-video',
    tags: ['client'],
  },
];

export const resourceTypes:ResourceType[] = [
  {
    type: 'doc',
    icon: 'fa fa-file-alt',
    label: 'Documents',
  },
  {
    type: 'video',
    icon: 'fa fa-file-video',
    label: 'Videos',
  },
];

export const resourceGroups:ResourceGroup[] = [
  {
    icon: 'fa fa-users',
    label: 'For Law Firms',
    tags: ['law-firm'],
  },
  {
    icon: 'fa fa-user',
    label: 'For Clients',
    tags: ['client'],
  },
];

export function findByTags(tags: string[]): Resource[] {
  const all = [...videos, ...documents];
  return all.filter(r => tags.some(tag => r.tags.includes(tag)));
}
